import $ from "jquery";

class SubMenu {
    constructor() {
        this.init();
    }

    init() {
        this.dom();
        this.events();

        this.initialHandler();
    }

    dom() {
        this.$subMenuWrap = $('.sub-menu-wrap');
        this.$subMenuActive = this.$subMenuWrap.find('> a:first-child');
    }

    events() {
        this.$subMenuActive.off('click.SubMenu');
        this.$subMenuActive.on('click.SubMenu', this.toggleSubMenuHandler.bind(this));
    }

    toggleSubMenuHandler(event) {
        event.preventDefault();

        if (!this.$subMenuWrap.hasClass('is-active')) {
            this.$subMenuWrap.addClass('is-active');
        } else {
            this.$subMenuWrap.removeClass('is-active');
        }
    }

    initialHandler() {
        const activeItemText = this.$subMenuWrap.find('> ul li.is-active a').text();
        if (activeItemText) {
            this.$subMenuActive.text(activeItemText);
        }
    }
}

export default SubMenu;